import { v4 as uuidv4 } from "uuid";

export class UnmatchedCard {
  constructor(cardJSON = {}) {
    this.title = cardJSON.title ?? "";
    this.type = cardJSON.type ?? "versatile";
    this.characterName = cardJSON.characterName ?? "ANY";
    this._value = cardJSON.value ?? 2;
    this.boost = cardJSON.boost ?? 1;
    this._effects = {
      basic: cardJSON.basicText ?? "",
      immediate: cardJSON.immediateText ?? "",
      during: cardJSON.duringText ?? "",
      after: cardJSON.afterText ?? ""
    };
    this.imageUrl = cardJSON.imageUrl ?? "";
    this.quantity = cardJSON.quantity ?? 1;
    this._uuid = uuidv4();
  }

  get value() {
    return this.type === "scheme" ? null : this._value;
  }

  set value(val) {
    this._value = val;
  }

  get basicText() {
    return this._effects.basic;
  }

  set basicText(val) {
    this._effects.basic = val;
  }

  get immediateText() {
    return this.type === "scheme" ? null : this._effects.immediate;
  }

  set immediateText(val) {
    this._effects.immediate = val;
  }

  get duringText() {
    return this.type === "scheme" ? null : this._effects.during;
  }

  set duringText(val) {
    this._effects.during = val;
  }

  get afterText() {
    return this.type === "scheme" ? null : this._effects.after;
  }

  set afterText(val) {
    this._effects.after = val;
  }

  get description() {
    var description = `${this.characterName}\n${this.type}`;

    if (this.value) description += ` ${this.value}`;

    description += `\nBoost ${this.boost}`;

    if (this.basicText) description += `\n${this.basicText}`;
    if (this.immediateText)
      description += `\nIMMEDIATELY: ${this.immediateText}`;
    if (this.duringText) description += `\nDURING COMBAT: ${this.duringText}`;
    if (this.afterText) description += `\nAFTER COMBAT: ${this.afterText}`;

    description += `\nx${this.quantity}`;

    return description;
  }

  toJSON() {
    let {
      title,
      type,
      characterName,
      value,
      boost,
      basicText,
      immediateText,
      duringText,
      afterText,
      imageUrl,
      quantity
    } = this;
    return {
      title,
      type,
      characterName,
      value,
      boost,
      basicText,
      immediateText,
      duringText,
      afterText,
      imageUrl,
      quantity
    };
  }
}

export class UnmatchedHero {
  constructor(heroJSON = {}) {
    this.name = heroJSON.name ?? "Hero";
    this.isRanged = heroJSON.isRanged ?? false;
    this.hp = heroJSON.hp ?? 15;
    this.move = heroJSON.move ?? 2;
    this.specialAbility = heroJSON.specialAbility ?? "Special ability";
  }
}

export class UnmatchedSidekick {
  constructor(sidekickJSON = {}) {
    this.name = sidekickJSON.name ?? "Sidekick";
    this.isRanged = sidekickJSON.isRanged ?? false;
    this._hp = sidekickJSON.hp ?? 6;
    this.quantity = sidekickJSON.quantity ?? 1;
    this._quote = sidekickJSON.quote ?? "";
  }

  get hp() {
    return this.quantity === 1 ? this._hp : null;
  }

  set hp(val) {
    this._hp = val;
  }

  get quote() {
    return this.quantity === 0 ? this._quote : null;
  }

  set quote(val) {
    this._quote = val;
  }

  toJSON() {
    let { name, isRanged, hp, quantity, quote } = this;
    return { name, isRanged, hp, quantity, quote };
  }
}

export class UnmatchedDeck {
  constructor(deckJSON = {}) {
    this.name = deckJSON.name ?? "";
    this.hero = new UnmatchedHero(deckJSON.hero ?? {});
    this.sidekick = new UnmatchedSidekick(deckJSON.sidekick ?? {});
    this.appearance = deckJSON.appearance ?? {
      isPNP: false,
      borderColour:
        "#" + (0x1000000 + Math.random() * 0xffffff).toString(16).substr(1, 6),
      highlightColour:
        "#" + (0x1000000 + Math.random() * 0xffffff).toString(16).substr(1, 6),
      patternName: "",
      cardbackUrl: ""
    };
    this.appearance.cardbackUrl = this.appearance.cardbackUrl ?? "";
    this.cards = deckJSON.cards
      ? deckJSON.cards.map(card => new UnmatchedCard(card))
      : [];
    this.ruleCards = deckJSON.ruleCards ?? [];
    this.extraCharacters = deckJSON.extraCharacters ?? [];
    this.extraCharacters = this.extraCharacters.map(character => {
      return {
        hero: new UnmatchedHero(character.hero ?? {}),
        sidekick: new UnmatchedSidekick(character.sidekick ?? {})
      };
    });
  }
}

export class UnmatchedCharacter {
  constructor(deckJSON = {}) {
    this.hero = new UnmatchedHero(deckJSON.hero ?? {});
    this.sidekick = new UnmatchedSidekick(deckJSON.sidekick ?? {});
  }
}
